
<script>   
    
    import { emailValidator, requiredValidator } from '../scripts/validators.js'
    import { createFieldValidator } from '../scripts/validation.js'
    import { fade } from 'svelte/transition';
    import { cubicInOut } from 'svelte/easing';
    import fadeScale from '../scripts/svelte-transitions-fade-scale.js';

    const [ validity, validate ] = createFieldValidator(requiredValidator(), emailValidator())	
    // const endpoint_url = "https://api.lfcamacho.com/";
    const endpoint_url = "https://formhandler.lfcamacho.workers.dev/";

    // let cf_turnstile;
    
    let activate_spinner = false;
    let show_error = false;
    let input_disabled =false;
    let successful = false;
    
	let email_field = null;
	let name_field = "";
	let message_field = "";
	let _lastname_field = "";
    let hasValidToken = false;
    
    $: disabled = !$validity.valid || name_field === "" || message_field === "" || _lastname_field !== "" || hasValidToken === false;


    window.turnstileCb = function () {

        // console.log("Turnstile CB called");
        
        turnstile.render('.cf-turnstile', {
            sitekey: "0x4AAAAAAABZVjN1N_ElipkK",
            callback: function(token) {
                // console.log(`Challenge Success ${token}`);
                hasValidToken = true;
            },
            'expired-callback': function(expired_cb) {
                // console.log('Token expired - ' + expired_cb);
                if(hasValidToken){
                    hasValidToken = false;
                    turnstile.reset('.cf-turnstile')
                } else {
                    hasValidToken = false;
                }
            }
            
        });      
    };

    
    function isFormValid(d) {
        if(d._lastname === "") {
            let isValid = (value) => { return value != null && value !== ""; }
            if(isValid(d.name) && isValid(d.email) && isValid(d.message)){ return true; }
        }
    }

    function disable_form(){
        input_disabled = true;
        disabled = true;
    }

    function enable_form(){
        input_disabled = false;
        disabled = false;

        email_field = "";
	    name_field = "";
	    message_field = "";
    }

    function show_error_response(){
        show_error = true;
        activate_spinner = false;
        setTimeout(() => { 
            show_error = false;
            enable_form();
        }, 15000)
    }

    function sendMock(state) {  //this is only used to test the contact form transitions

        disable_form();        
        
        if(state === 'error'){
            setTimeout(() => { 
                show_error = true;
                activate_spinner = false;
             }, 2000)
             setTimeout(() => { 
                show_error = false;
                enable_form();
             }, 15000)
        } else if(state ==='success'){
            setTimeout(() => { 
                activate_spinner = false;
                successful = true;
             }, 2000)
        }        
    }
    

    async function doPost () {

        var myHeaders = new Headers();
        myHeaders.append("Origin", "https://www.lfcamacho.com");
        myHeaders.append("Content-Type", "application/json");

        var dataToSend = JSON.stringify({
            "Message_Body": {
                "name": name_field,
                "email": email_field,
                "message": message_field
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: dataToSend,
            redirect: 'follow'
        };

        await fetch(endpoint_url, requestOptions)
        // .then(response => response.text())     
        .then( (response) => {             
            
            if(response.status === 202) {

                // console.log(response.status)
                activate_spinner = false;
                successful = true;

            }else if (response.status === 400 || response.status === 500) {
                // console.log(response.status)
                show_error_response();

            } else {
                // console.log(response.status)
                console.log("Unknown Error");
                show_error_response();
            }
        })
        // .then(result => console.log(result + 'ooooof'))
        .catch((error) => {
            console.log('error found, please log the response for more details', error);
            show_error_response();
        });
        
	}    
    
    function onSubmit(e) {
        
        const formData = new FormData(e.target);
        const data = {};
        
        for (let field of formData) {
            const [key, value] = field;
            data[key] = value;
        }
        
        if(isFormValid(data)){
            activate_spinner = true;
            disable_form(); 
            doPost();
            // sendMock("success") //use this instead of doPost() to test the form, with "success" or "error"
        } else {
            console.log("Invalid Form")
        }
    }    

</script>



<div class="divider"></div>

<div id="contact_form" class="section">
    <div class="container">
        <div class="row form-row">
            {#if !successful }
            <form out:fade="{{duration: 500}}" on:submit|preventDefault={onSubmit} method="post" >
                <h4 fade class="blue-grey-text text-lighten-2">Contact form</h4>
                    <div class="row">
                        <div class="input-field col s12 m6">
                            <i class="material-icons prefix"><img src="/media/icons/material-icons/outline_person_black_24dp.png" alt="outline person icon - LFCamacho"></i>
                            <input 
                                id="name" 
                                type="text" 
                                name="name" 
                                class="validate"
                                bind:value={name_field}
                                minlength="2"
                                disabled={input_disabled}
                                required>
                            <label for="name">Name</label>
                            <input type="hidden" name="_lastname" bind:value={_lastname_field} style="display:none !important">
                        </div>
                        <div class="input-field col s12 m6">
                            <i class="material-icons prefix"><img src="/media/icons/material-icons/outline_email_black_24dp.png" alt="outline email icon - LFCamacho"></i>
                            <input 
                                id="email" 
                                type="email" 
                                name="email" 
                                class="validate" 
                                bind:value={email_field} 
                                class:field-danger={!$validity.valid}
                                class:field-success={$validity.valid}
                                use:validate={email_field}
                                disabled={input_disabled}
                                required>
                            <label for="email">Email</label>
                        </div>
                    </div>

                    <div class="row">                                     
                        <div class="input-field col s12">
                            <i class="material-icons prefix"><img src="/media/icons/material-icons/outline_comment_black_24dp.png" alt="outline comment icon - LFCamacho"></i>
                            <textarea 
                                id="textarea" 
                                type="text" 
                                name="message" 
                                class="materialize-textarea"                            
                                bind:value={message_field}
                                disabled={input_disabled}
                                required></textarea>
                            <label for="textarea">Message</label>
                        </div>                    
                    </div>

                    <div class="row">
                        <div class="cf-turnstile"></div>
                    </div>

                    <div class="row">
                        <div class="input-field col s12 submitting">
                            <button class="btn waves-effect waves-light cyan darken-3"
                                    type="submit"
                                    disabled={disabled}
                                    >Submit<i class="material-icons right"><img src="/media/icons/material-icons/outline_send_black_24dp.png" alt="outline send icon - LFCamacho"></i>                            
                            </button>

                            <div class:active="{activate_spinner}" class="preloader-wrapper small">
                            <!-- <div class:active="{preloader-wrapper small}"> -->
                                <div class="spinner-layer">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                            <div class:show="{show_error}" class="error_message red-text text-darken-4">
                                <p>Something went wrong, please try again later!</p>
                            </div>
                        </div>

                    </div>
                </form>
            {:else}
            <div id="submitted"  class="success_section">
                <div transition:fadeScale="{{delay: 550, easing: cubicInOut, baseScale:2.5}}" class="success_icon center">
                    <i class="material-icons teal-text text-accent-4"><img src="/media/icons/material-icons/outline_check_circle_black_24dp.png" alt="outline check circle icon - LFCamacho"></i>
                </div>
                <h4 in:fade="{{delay: 550}}" class="success_text teal-text text-accent-4 center">Your message was sucessfully sent! I'll get back at you as soon as I can.</h4>
            </div>    

            {/if}
            
        </div>
    </div>
</div>

<style>
    label {color:#546e7a;}
    .spinner-layer { border-color: #00838f; }
    .submitting, #contact_form .container {display: flex; justify-content: start; align-items: center;}
    .submitting button{margin-right: 1em;}
    .preloader-wrapper.small { width: 20px; height: 20px; }
    .error_message {display: none; }
    .error_message.show {display: block; margin-left:1em; }
    .success_icon i {font-size: 5em;}
    #contact_form .container {min-height: 350px;}
    .form-row { width: 100%; }
    #contact_form {background-color: #f5f3f2;}
    .submitting .btn i {padding-top: 5px;}

</style>